import styled from 'styled-components';
import { constants } from '@thecb/components';

/**
 * Explanation: trying to recreate a Grid (from cb-pos)
 * left-aligned, wrapping, should maximize width,
 * but can have empty columns in the last row.
 * The <Cluster> component takes care of the outer box,
 * these styles provide the flex-grow and max-width properties
 * for the card wrapper and card content elements
 *  _______________
 * |  ____   ____  |
 * | |_12_| |_34_| |
 * |  ____         |
 * | |_56_|        |
 * |_______________|
 */

export const AgencyTileWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  max-width: calc(33% - 5px);
  font-size: 1rem;

  a {
    flex-grow: 1;
    text-align: center;
    text-decoration: none;
    color: ${constants.colors.WHITE};
    position: relative;
    box-sizing: border-box;
    padding: 1rem 1.25rem;
    min-height: 4rem;
    background-color: ${(props) =>
      props.rebrand
        ? constants.colors.LUCKY_POINT
        : constants.colors.MATISSE_BLUE};
    border: 2px solid
      ${(props) =>
        props.rebrand
          ? constants.colors.LUCKY_POINT
          : constants.colors.MATISSE_BLUE};
    min-width: 250px;
    border-radius: 4px;
    transition: all 0.2s linear;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 1rem;
    font-weight: 600;

    &:hover {
      background: ${(props) =>
        props.rebrand ? constants.colors.LUCKY_POINT_DARK : '#0f5370'};
      border-color: ${(props) =>
        props.rebrand ? constants.colors.LUCKY_POINT_DARK : '#0f5370'};
    }
  }
`;

export const ProductTileWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  max-width: calc(33% - 5px);
  font-size: 1rem;

  a {
    flex-grow: 1;
    text-align: center;
    text-decoration: none;
    color: ${(props) =>
      props.rebrand
        ? constants.colors.LUCKY_POINT
        : constants.colors.MATISSE_BLUE};
    position: relative;
    box-sizing: border-box;
    padding: 1rem 1.25rem;
    min-height: 4rem;
    background-color: ${constants.colors.WHITE};
    border: 2px solid
      ${(props) =>
        props.rebrand
          ? constants.colors.LUCKY_POINT
          : constants.colors.MATISSE_BLUE};
    min-width: 250px;
    border-radius: 4px;
    transition: all 0.2s linear;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 1rem;
    font-weight: 600;

    &:hover {
      background: ${(props) =>
        props.rebrand ? constants.colors.HAWKES_BLUE : '#dbeaf0'};
      border-color: ${(props) =>
        props.rebrand ? constants.colors.LUCKY_POINT : '#0f5370'};
    }
  }
`;
